import { VerificationBadge } from 'components/VerificationBadge/VerificationBadge';

function attentionConfigAllowsPreCompletionDisplay(checkType) {
  const cfg = checkType?.attention_flag_config;
  if (!cfg) return false;
  const rules = [...(cfg.attention_rules || []), ...(cfg.subcheck_attention_rules || [])];
  return rules.some(rule => rule?.requires_completed_check === false);
}

export function isScreeningAttentionVisible(check, checkType) {
  if (!checkType || !check) return false;
  if (check.canceled) return false;
  if (!check.attention_flag) return false;

  if (!check.completed_at && !attentionConfigAllowsPreCompletionDisplay(checkType)) {
    return false;
  }

  if (!checkType.has_result_flag) return true;
  return !check.result_flag;
}

export function screeningStatusPill(check, checkType) {
  if (!checkType || !check || check.canceled) return null;
  const attentionVisible = isScreeningAttentionVisible(check, checkType);
  const attentionText = checkType.attention_flag_config?.attention_label || 'Needs attention';
  if (checkType.has_result_flag && check.completed_at) {
    if (check.result_flag) {
      return { text: checkType.true_flag_label || 'Result', status: 'error' };
    }
    if (attentionVisible) {
      return { text: attentionText, status: 'warning' };
    }
    return { text: checkType.false_flag_label || 'Clear', status: 'success' };
  }
  if (attentionVisible) {
    return { text: attentionText, status: 'warning' };
  }
  return null;
}

export function screeningVerificationBadge(check, checkType) {
  if (!checkType || !check) return null;
  if (check.canceled) return null;
  const cfg = checkType.attention_flag_config;
  const attentionTip = cfg?.attention_label || 'Needs attention';
  const resultBand = checkType.has_result_flag && check.completed_at;
  const attentionVisible = isScreeningAttentionVisible(check, checkType);
  if (resultBand) {
    const status = check.result_flag ? 'critical' : attentionVisible ? 'attention' : 'success';
    const tipMap = {
      critical: checkType.true_flag_label,
      attention: attentionTip,
      success: checkType.false_flag_label,
    };
    return (
      <VerificationBadge className="u-margin-right--small" type={status} tip={tipMap[status]} />
    );
  }
  if (attentionVisible) {
    return (
      <VerificationBadge className="u-margin-right--small" type="attention" tip={attentionTip} />
    );
  }
  return null;
}
